module.exports = __webpack_public_path__ + "fonts/summernote.c7cbf18f.ttf";